import { render } from "./VirtualKeyboard.vue?vue&type=template&id=4cf14799&scoped=true"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js"

import "./VirtualKeyboard.vue?vue&type=style&index=0&id=4cf14799&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf14799"]])

export default __exports__